import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=301d3160&scoped=true"
import script from "@/views/Settings/Settings.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Settings.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/settings.scss?vue&type=style&index=0&id=301d3160&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301d3160",
  null
  
)

export default component.exports